export const AGORA_APP_ID = 'aefab4223e9e49c8a9142aa0a7516684';
export const AGORA_CUSTOMER_KEY = 'cec6e484195741f28b978e96b5e3eca7';
